export default {

    UNREVIEWED: {
        code: 1,
        title: '待审核'
    },
    AUDIT_SUCCESS: {
        code: 2,
        title: '审核成功'
    },
    AUDIT_FAILURE: {
        code: 3,
        title: '审核失败'
    },

    /**
     * @param   String  title   biz type's title
     * @returns String          biz type's key
     * @author  zhiwen
     */
    getKeyByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return key;
            }
        }

        return '';
    },

    /**
     * @param   String  title   biz type's title
     * @returns String|Number   biz type's code
     * @author  zhiwen
     */
    getCodeByTitle : function (title) {

        for (let key in this)
        {
            if (typeof(this[key]) != 'object')
            {
                continue;
            }

            if (this[key].title == title)
            {
                return this[key].code;
            }
        }

        return '';
    }

}
